import { useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { Users, MapPinned, Menu, X, Satellite, BookOpen, UserCheck } from 'lucide-react'
import Header from '../components/Header'

function MainLayout() {
  const [open, setOpen] = useState(true)

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Aside */}
      <aside className={`transition-all duration-200 bg-gray-900 text-white ${open ? 'w-56' : 'w-16'} flex flex-col shadow-lg z-20`}>
        <div className="flex items-center justify-between px-4 py-4 border-b border-gray-800">
          <span className={`font-bold text-lg tracking-wide transition-all duration-200 ${open ? 'opacity-100' : 'opacity-0 w-0 overflow-hidden'}`}>GRUPO TECNYTTE</span>
          <button onClick={() => setOpen(!open)} className="ml-auto text-gray-400 hover:text-white focus:outline-none">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        <nav className="flex-1 py-4">
          <ul className="space-y-2">
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded transition-colors duration-150 hover:bg-gray-800 ${isActive ? 'bg-gray-800 font-semibold' : ''}`
                }
              >
                <Users className="w-5 h-5" />
                <span className={`${open ? 'block' : 'hidden'}`}>Gestión de Clientes</span>
              </NavLink>
            </li>
            {/*
            <li>
              <NavLink
                to="/programaciones-gps"
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded transition-colors duration-150 hover:bg-gray-800 ${isActive ? 'bg-gray-800 font-semibold' : ''}`
                }
              >
                <MapPinned className="w-5 h-5" />
                <span className={`${open ? 'block' : 'hidden'}`}>Gestión Programaciones GPS</span>
              </NavLink>
            </li>
            */}
            <li>
              <NavLink
                to="/simulaciones-gps"
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded transition-colors duration-150 hover:bg-gray-800 ${isActive ? 'bg-gray-800 font-semibold' : ''}`
                }
              >
                <Satellite className="w-5 h-5" />
                <span className={`${open ? 'block' : 'hidden'}`}>Gestión Simulaciones GPS</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/usuarios"
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded transition-colors duration-150 hover:bg-gray-800 ${isActive ? 'bg-gray-800 font-semibold' : ''}`
                }
              >
                <UserCheck className="w-5 h-5" />
                <span className={`${open ? 'block' : 'hidden'}`}>Gestión de Usuarios</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/manual-usuario"
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded transition-colors duration-150 hover:bg-gray-800 ${isActive ? 'bg-gray-800 font-semibold' : ''}`
                }
              >
                <BookOpen className="w-5 h-5" />
                <span className={`${open ? 'block' : 'hidden'}`}>Manual de Usuario</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </aside>
      {/* Contenido principal */}
      <main className="flex-1 min-w-0">
        <Header />
        <Outlet />
      </main>
    </div>
  )
}

export default MainLayout 